export type PopupCloseCallback = (sender: Telerik.Web.UI.RadWindow, args: Telerik.Web.UI.WindowCloseEventArgs) => void;
export type PopupOpenCallback = (sender: Telerik.Web.UI.RadWindow, args: Sys.EventArgs) => void;

export class PopupProperties {
    url: string;
    params?: any;
    title: string;
    width?: string;
    height?: string;
    callback?: PopupCloseCallback;
    windowName?: string;

    constructor() {        
        this.height = "75%";
        this.width = "75%";
    }
}